import { fetchArticleById } from 'core_main/api/articles';
import { PublicCallback } from 'globals/types';
import { createArticleCallbackResponse } from '../get_articles/helpers';
import { GetArticleByIdParameters } from '../get_articles/types';

export const getArticleById = (
  parameters: GetArticleByIdParameters,
  cb?: PublicCallback,
) => {
  return fetchArticleById(parameters)
    .then((res) => {
      const callbackResponse = createArticleCallbackResponse(res.data);

      if (typeof cb === 'function') {
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to get article', error);
    });
};
